<template>    
  <div class='h100-40 width-100vw' :style="styleColorVar">
    <div class="h100-80 h-scroll">
    <ejs-grid ref='grid'  height='100%' id='alarmPageId' :dataSource='data' :contextMenuItems='contextMenuItems' :contextMenuOpen='menuBeforeOpenFunc' :contextMenuClick='menuClickFunc' :excelExportComplete='excelExportComplete' :actionComplete='actionComplete'
              :editSettings='editOptions' :selectionSettings='selectionOptions' :allowReordering='true' :allowResizing='true' :allowExcelExport='true' :allowSorting="true"  :enableVirtualization='true' :allowPaging='true'>
      <e-columns>
        <e-column type='checkbox' textAlign='Center' minWidth='8' width='6%'></e-column>
        <e-column v-if='!hidden.messageNo'  :isPrimaryKey='true' :visible='true' field='messageNo'   :allowSorting="false" :headerText='$t("Alarm.messageNo")' textAlign='Center' clipMode='EllipsisWithTooltip' minWidth='10' width='8%'></e-column>
        <e-column v-if='hidden.messageNo'  :isPrimaryKey='true' :visible='false' field='messageNo' :allowSorting="false"  :headerText='$t("Alarm.messageNo")' textAlign='Center' clipMode='EllipsisWithTooltip' minWidth='10' width='8%'></e-column>
        <e-column v-if='!hidden.alarmID'  :visible='true' field='alarmID' :allowSorting="false" :headerText='$t("Alarm.alarmID")' textAlign='Center' clipMode='EllipsisWithTooltip' minWidth='10' width='8%'></e-column>
        <e-column v-if='hidden.alarmID'  :visible='false' field='alarmID' :allowSorting="false" :headerText='$t("Alarm.alarmID")' textAlign='Center' clipMode='EllipsisWithTooltip' minWidth='10' width='8%'></e-column>
        <e-column v-if='!hidden.alarmName'  :visible='true' field='alarmName' :allowSorting="false"  :headerText='$t("Alarm.alarmName")' textAlign='Center' clipMode='EllipsisWithTooltip' minWidth='10' width='10%'></e-column>
        <e-column v-if='hidden.alarmName'  :visible='false' field='alarmName' :allowSorting="false" :headerText='$t("Alarm.alarmName")' textAlign='Center' clipMode='EllipsisWithTooltip' minWidth='10' width='10%'></e-column>
        <e-column  v-if='!hidden.levelStr'   :visible='true' field='levelStr' :headerText='$t("Alarm.alarmLevel")' textAlign='Center'  clipMode='EllipsisWithTooltip' :disableHtmlEncode='false' :formatter='levelFormat' minWidth='10' width='8%'></e-column>
        <e-column  v-if='hidden.levelStr'   :visible='false' field='levelStr' :headerText='$t("Alarm.alarmLevel")' textAlign='Center'  clipMode='EllipsisWithTooltip' :disableHtmlEncode='false' :formatter='levelFormat' minWidth='10' width='8%'></e-column>
        <e-column v-if='!hidden.alarmTypeStr'  :visible='true' field='alarmTypeStr' :allowSorting="false"  :headerText='$t("Alarm.alarmType")' textAlign='Center' :formatter='typeFormat' minWidth='10' width='8%'></e-column>
        <e-column v-if='hidden.alarmTypeStr'  :visible='false' field='alarmTypeStr' :allowSorting="false"  :headerText='$t("Alarm.alarmType")' textAlign='Center' :formatter='typeFormat' minWidth='10' width='8%'></e-column>
        <e-column v-if='!hidden.nodeType' :visible='true' field='nodeType' :allowSorting="false"  :headerText='$t("Topo.nodeType")' textAlign='Center' clipMode='EllipsisWithTooltip' minWidth='10' width='8%'></e-column>
        <e-column v-if='hidden.nodeType' :visible='false' field='nodeType' :allowSorting="false"  :headerText='$t("Topo.nodeType")' textAlign='Center' clipMode='EllipsisWithTooltip' minWidth='10' width='8%'></e-column>
        <!-- 2023-9-21 完全隐藏：网元名称、网元类型、设备类型、部署IP， 不在隐藏/显示功能显示，不导出、详细信息中也要去掉 -->
        <!--
        <e-column v-if='!hidden.neTypeStr' :visible='true' field='neTypeStr' :headerText='$t("Alarm.neType")' textAlign='Center' clipMode='EllipsisWithTooltip' minWidth='10' width='8%'></e-column>
        <e-column v-if='hidden.neTypeStr' :visible='false' field='neTypeStr' :headerText='$t("Alarm.neType")' textAlign='Center' clipMode='EllipsisWithTooltip' minWidth='10' width='8%'></e-column>
    
        <e-column v-if='!hidden.neName' :visible='true' field='neName' :headerText='$t("Alarm.neName")' textAlign='Center' clipMode='EllipsisWithTooltip' minWidth='10'></e-column>
        <e-column v-if='hidden.neName' :visible='false' field='neName' :headerText='$t("Alarm.neName")' textAlign='Center' clipMode='EllipsisWithTooltip' minWidth='10'></e-column>
        <e-column v-if='!hidden.equipmentType' :visible='true' field='equipmentType' :headerText='$t("Alarm.equipmentType")' textAlign='Center' clipMode='EllipsisWithTooltip' minWidth='10'></e-column>
        <e-column v-if='hidden.equipmentType' :visible='false' field='equipmentType' :headerText='$t("Alarm.equipmentType")' textAlign='Center' clipMode='EllipsisWithTooltip' minWidth='10'></e-column>
        <e-column v-if='!hidden.deployIp' :visible='true' field='deployIp' :headerText='$t("Alarm.deployIp")' textAlign='Center' minWidth='10' clipMode='EllipsisWithTooltip'></e-column>
        <e-column v-if='hidden.deployIp' :visible='false' field='deployIp' :headerText='$t("Alarm.deployIp")' textAlign='Center' minWidth='10' clipMode='EllipsisWithTooltip'></e-column>
        -->

        <e-column v-if='!hidden.equipmentName' :visible='true' field='equipmentName' :headerText='$t("Alarm.equipmentName")' textAlign='Center' clipMode='EllipsisWithTooltip' minWidth='10' width='8%'></e-column>
        <e-column v-if='hidden.equipmentName' :visible='false' field='equipmentName' :headerText='$t("Alarm.equipmentName")' textAlign='Center' clipMode='EllipsisWithTooltip' minWidth='10' width='8%'></e-column>
        <e-column v-if='!hidden.neAlarmFDN'  :visible='true' field='neAlarmFDN' :allowSorting="false" :headerText='$t("Alarm.neAlarmFDN")' textAlign='Center' minWidth='10' clipMode='EllipsisWithTooltip' width='8%'></e-column>
        <e-column v-if='hidden.neAlarmFDN'  :visible='false' field='neAlarmFDN' :allowSorting="false" :headerText='$t("Alarm.neAlarmFDN")' textAlign='Center' minWidth='10' clipMode='EllipsisWithTooltip' width='8%'></e-column>

        <e-column v-if='!hidden.brdTypeStr'  :visible='true' field='brdTypeStr' :allowSorting="false" :headerText='$t("Alarm.brdType")' textAlign='Center' clipMode='EllipsisWithTooltip' minWidth='10' width='8%'></e-column>
        <e-column v-if='hidden.brdTypeStr'  :visible='false' field='brdTypeStr' :allowSorting="false" :headerText='$t("Alarm.brdType")' textAlign='Center' clipMode='EllipsisWithTooltip' minWidth='10' width='8%'></e-column>

        <e-column v-if='!hidden.appendInfo'  :visible='true' field='appendInfo' :allowSorting="false" :headerText='$t("Alarm.extraInfo")' textAlign='Center' clipMode='EllipsisWithTooltip' minWidth='10' width='8%'></e-column>
        <e-column v-if='hidden.appendInfo'  :visible='false' field='appendInfo' :allowSorting="false" :headerText='$t("Alarm.extraInfo")' textAlign='Center' clipMode='EllipsisWithTooltip' minWidth='10' width='8%'></e-column>
        <e-column v-if='!hidden.xxdwinfo1'  :visible='true' field='xxdwinfo1' :allowSorting="false" :headerText='$t("Alarm.xxdwinfo1")' textAlign='Center' clipMode='EllipsisWithTooltip' minWidth='10' width='8%'></e-column>
        <e-column v-if='hidden.xxdwinfo1'  :visible='false' field='xxdwinfo1' :allowSorting="false" :headerText='$t("Alarm.xxdwinfo1")' textAlign='Center' clipMode='EllipsisWithTooltip' minWidth='10' width='8%'></e-column>


        <!-- <e-column v-if='!hidden.deployIp_Id' :visible='true' field='deployIp_Id' :headerText='$t("Alarm.deployIpId")' textAlign='Center' minWidth='10' clipMode='EllipsisWithTooltip'></e-column> -->
        <!-- <e-column v-if='hidden.deployIp_Id' :visible='false' field='deployIp_Id' :headerText='$t("Alarm.deployIpId")' textAlign='Center' minWidth='10' clipMode='EllipsisWithTooltip'></e-column> -->

        <!-- <e-column v-if='!hidden.envTypeName' :visible='true' field='envTypeName' :headerText='$t("Alarm.envType")' textAlign='Center' clipMode='EllipsisWithTooltip' minWidth='10'></e-column> -->
        <!-- <e-column v-if='hidden.envTypeName' :visible='false' field='envTypeName' :headerText='$t("Alarm.envType")' textAlign='Center' clipMode='EllipsisWithTooltip' minWidth='10'></e-column> -->
        <!-- <e-column v-if='!hidden.envName' :visible='true' field='envName' :headerText='$t("Alarm.envName")' textAlign='Center' clipMode='EllipsisWithTooltip' minWidth='10'></e-column>
        <e-column v-if='hidden.envName' :visible='false' field='envName' :headerText='$t("Alarm.envName")' textAlign='Center' clipMode='EllipsisWithTooltip' minWidth='10'></e-column> -->

        <!-- <e-column v-if='!hidden.nodeTypeId' :visible='true' field='nodeTypeId' :headerText='$t("Alarm.isvirtual")' textAlign='Center' minWidth='10' clipMode='EllipsisWithTooltip' :formatter='isVirtualFormat'></e-column> -->
        <!-- <e-column v-if='hidden.nodeTypeId' :visible='false' field='nodeTypeId' :headerText='$t("Alarm.isvirtual")' textAlign='Center' minWidth='10' clipMode='EllipsisWithTooltip' :formatter='isVirtualFormat'></e-column> -->

        <!-- <e-column field='clearStateStr' :headerText='$t("Alarm.clearState")' textAlign='Center' :formatter='clearFormat' minWidth='10'></e-column> -->
        <e-column v-if='!hidden.createTimeFormat' :visible='true' field='createTimeFormat' :headerText='$t("Alarm.createTime")' textAlign='Center' clipMode='EllipsisWithTooltip' minWidth='10' width='11%'></e-column>
        <e-column v-if='hidden.createTimeFormat' :visible='false' field='createTimeFormat' :headerText='$t("Alarm.createTime")' textAlign='Center' clipMode='EllipsisWithTooltip' minWidth='10' width='11%'></e-column>
        <e-column v-if='!hidden.confirmStateStr'  :visible='true' field='confirmStateStr' :allowSorting="false" :headerText='$t("Alarm.confirmState")' textAlign='Center' :formatter='confirmFormat' clipMode='EllipsisWithTooltip' minWidth='10' width='8%'></e-column>
        <e-column v-if='hidden.confirmStateStr'  :visible='false' field='confirmStateStr' :allowSorting="false" :headerText='$t("Alarm.confirmState")' textAlign='Center' :formatter='confirmFormat' clipMode='EllipsisWithTooltip' minWidth='10' width='8%'></e-column>
        <!-- <e-column field='clearTimeFormat' :headerText='$t("Alarm.clearTime")' textAlign='Center' clipMode='EllipsisWithTooltip' minWidth='10'></e-column> -->
        <e-column v-if='!hidden.confirmTimeFormat'  :visible='true' field='confirmTimeFormat' :allowSorting="false" :headerText='$t("Alarm.confirmTime")' textAlign='Center' clipMode='EllipsisWithTooltip' minWidth='10' width='11%'></e-column>
        <e-column v-if='hidden.confirmTimeFormat'  :visible='false' field='confirmTimeFormat' :allowSorting="false" :headerText='$t("Alarm.confirmTime")' textAlign='Center' clipMode='EllipsisWithTooltip' minWidth='10' width='11%'></e-column>
        <!-- <e-column field='clearUsrName' :headerText='$t("Alarm.clearUser")' textAlign='Center' clipMode='EllipsisWithTooltip' minWidth='10'></e-column> -->
        <e-column v-if='!hidden.confirmUsrName'  :visible='true' field='confirmUsrName' :allowSorting="false" :headerText='$t("Alarm.confirmUser")' textAlign='Center' clipMode='EllipsisWithTooltip' minWidth='10' width='8%'></e-column>
        <e-column v-if='hidden.confirmUsrName'  :visible='false' field='confirmUsrName' :allowSorting="false" :headerText='$t("Alarm.confirmUser")' textAlign='Center' clipMode='EllipsisWithTooltip' minWidth='10' width='8%'></e-column>

        <e-column v-if='!hidden.xxdwinfo2'  :visible='true' field='xxdwinfo2' :allowSorting="false" :headerText='$t("Alarm.xxdwinfo2")' textAlign='Center' minWidth='10' clipMode='EllipsisWithTooltip' width='8%'></e-column>
        <e-column v-if='hidden.xxdwinfo2'  :visible='false' field='xxdwinfo2' :allowSorting="false" :headerText='$t("Alarm.xxdwinfo2")' textAlign='Center' minWidth='10' clipMode='EllipsisWithTooltip' width='8%'></e-column>
        <e-column v-if='!hidden.xxkzinfo1'  :visible='true' field='xxkzinfo1' :allowSorting="false" :headerText='$t("Alarm.xxkzinfo1")' textAlign='Center' minWidth='10' clipMode='EllipsisWithTooltip' width='8%'></e-column>
        <e-column v-if='hidden.xxkzinfo1'  :visible='false' field='xxkzinfo1' :allowSorting="false" :headerText='$t("Alarm.xxkzinfo1")' textAlign='Center' minWidth='10' clipMode='EllipsisWithTooltip' width='8%'></e-column>
        <e-column v-if='!hidden.xxkzinfo2'  :visible='true' field='xxkzinfo2' :allowSorting="false" :headerText='$t("Alarm.xxkzinfo2")' textAlign='Center' minWidth='10' clipMode='EllipsisWithTooltip' width='8%'></e-column>
        <e-column v-if='hidden.xxkzinfo2'  :visible='false' field='xxkzinfo2' :allowSorting="false" :headerText='$t("Alarm.xxkzinfo2")' textAlign='Center' minWidth='10' clipMode='EllipsisWithTooltip' width='8%'></e-column>
        <e-column v-if='!hidden.xxkzinfo3'  :visible='true' field='xxkzinfo3' :allowSorting="false" :headerText='$t("Alarm.xxkzinfo3")' textAlign='Center' minWidth='10' clipMode='EllipsisWithTooltip' width='8%'></e-column>
        <e-column v-if='hidden.xxkzinfo3'  :visible='false' field='xxkzinfo3' :allowSorting="false" :headerText='$t("Alarm.xxkzinfo3")' textAlign='Center' minWidth='10' clipMode='EllipsisWithTooltip' width='8%'></e-column>
        <e-column v-if='!hidden.xxkzinfo4'  :visible='true' field='xxkzinfo4' :allowSorting="false" :headerText='$t("Alarm.xxkzinfo4")' textAlign='Center' minWidth='10' clipMode='EllipsisWithTooltip' width='8%'></e-column>
        <e-column v-if='hidden.xxkzinfo4'  :visible='false' field='xxkzinfo4' :allowSorting="false" :headerText='$t("Alarm.xxkzinfo4")' textAlign='Center' minWidth='10' clipMode='EllipsisWithTooltip' width='8%'></e-column>
        <e-column v-if='!hidden.cause'  :visible='true' field='cause' :allowSorting="false" :headerText='$t("Alarm.cause")' textAlign='Center' minWidth='10' clipMode='EllipsisWithTooltip' width='8%'></e-column>
        <e-column v-if='hidden.cause'  :visible='false' field='cause' :allowSorting="false" :headerText='$t("Alarm.cause")' textAlign='Center' minWidth='10' clipMode='EllipsisWithTooltip' width='8%'></e-column>
        <e-column v-if='!hidden.advise'  :visible='true' field='advise' :allowSorting="false" :headerText='$t("Alarm.advise")' textAlign='Center' minWidth='10' clipMode='EllipsisWithTooltip' width='8%'></e-column>
        <e-column v-if='hidden.advise'  :visible='false' field='advise' :allowSorting="false" :headerText='$t("Alarm.advise")' textAlign='Center' minWidth='10' clipMode='EllipsisWithTooltip' width='8%'></e-column>
        <e-column v-if='!hidden.comment'  :visible='true' field='comment' :allowSorting="false" :headerText='$t("Alarm.remark")' textAlign='Center' minWidth='10' clipMode='EllipsisWithTooltip' width='8%'></e-column>
        <e-column v-if='hidden.comment'  :visible='false' field='comment' :allowSorting="false" :headerText='$t("Alarm.remark")' textAlign='Center' minWidth='10' clipMode='EllipsisWithTooltip' width='8%'></e-column>
        <!--
        <e-column field='xxdwinfo2' :headerText='$t("Alarm.xxdwinfo2")' :visible='false' textAlign='Center' width='9%'></e-column>
        <e-column field='xxkzinfo1' :headerText='$t("Alarm.xxkzinfo1")' :visible='false' textAlign='Center' width='9%'></e-column>
        <e-column field='xxkzinfo2' :headerText='$t("Alarm.xxkzinfo2")' :visible='false' textAlign='Center' width='9%'></e-column>
        <e-column field='xxkzinfo3' :headerText='$t("Alarm.xxkzinfo3")' :visible='false' textAlign='Center' width='9%'></e-column>
        <e-column field='xxkzinfo4' :headerText='$t("Alarm.xxkzinfo4")' :visible='false' textAlign='Center' width='9%'></e-column>
        <e-column field='cause' :headerText='$t("Alarm.cause")' :visible='false' textAlign='Center' width='9%'></e-column>
        <e-column field='advise' :headerText='$t("Alarm.advise")' :visible='false' textAlign='Center' width='9%'></e-column>
        <e-column field='comment' :headerText='$t("Alarm.remark")' :visible='false' textAlign='Center' width='9%'></e-column>
        <e-column field='messageNo' :isPrimaryKey='true' :headerText='$t("Alarm.messageNo")' :visible='false' textAlign='Center' width='9%' minWidth='10'></e-column>
        <e-column field='brdTypeStr' brdType:headerText='$t("Alarm.brdType")' :visible='false' textAlign='Center' width='9%'></e-column>
        -->
      </e-columns>
    </ejs-grid>
    </div>
    <ejs-pager ref='pager' @click='getAlarmListData()' :currentPage='page.pageNo' :pageSizes='page.pageSizes' :totalRecordsCount='page.totalCount'  :pageSize='page.pageSize' :pageCount='page.pageCount'></ejs-pager>
    <!-- <ejs-pager ref='pager' @click='getAlarmListData()' :currentPage='page.pageNo' :pageSize='page.pageSize' :totalRecordsCount='page.totalCount' :pageCount='page.pageCount'></ejs-pager> -->
    <CustomDialog ref='syncDialog' :element='syncDialogSetting.element' :styles='syncDialogSetting.styles'>
      <template v-slot:dialog-content>
        <div class='h-dialogContainer syncTopoTree'>
<!--          <TopoTree ref='syncContent' :searchBox='{ show: false }' :checkBox='{ show: true }'></TopoTree>-->
<!--          <TopoList ref='syncContent'></TopoList>-->
          <AlarmTopoTree ref='syncContent'></AlarmTopoTree>
        </div>
      </template>
    </CustomDialog>
    <CustomDialog ref='detailDialog' :element='detailDialogSetting.element' :styles='detailDialogSetting.styles'>
      <template v-slot:dialog-content>
        <AlarmDetail ref='detailContent'></AlarmDetail>
      </template>
    </CustomDialog>
    <CustomDialog ref='filterDialog' :element='filterDialogSetting.element' :styles='filterDialogSetting.styles'>
      <template v-slot:dialog-content>
        <AlarmFilter url='/lte/ems/fm/alarmcurrent/filter' ref='filterContent' :hasStatus='true'></AlarmFilter>
      </template>
    </CustomDialog>
    <CustomDialog ref='hiddenDialog' :element='hiddenDialogSetting.element' :styles='hiddenDialogSetting.styles'>
      <template v-slot:dialog-content>
        <AlarmHidden ref='hiddenContent'></AlarmHidden>
      </template>
    </CustomDialog>
    <CustomDialog ref='autoConfirmDialog' :element='autoConfirmDialogSetting.element' :styles='autoConfirmDialogSetting.styles'>
      <template v-slot:dialog-content>
        <AutoConfirm ref='autoConfigContent'></AutoConfirm>
      </template>
    </CustomDialog>
    <CustomDialog ref='updateDialog' :element='updateDialogSetting.element' :styles='updateDialogSetting.styles'>
      <template v-slot:dialog-content>
        <AlarmUpdate ref='updateSettingContent'></AlarmUpdate>
      </template>
    </CustomDialog>
</div>

</template>
<script>
const a = true;
import { Edit, Reorder, Resize, ExcelExport, ContextMenu, GridPlugin, VirtualScroll, GridComponent, Sort, PagerComponent, Pager, PagerDropDown } from '@syncfusion/ej2-vue-grids';
import CustomDialog from '../../common/CustomDialog';
import AlarmTopoTree from './AlarmTopoTree';
import AlarmDetail from './AlarmDetail';
import AlarmHidden from './AlarmHidden';
import AlarmFilter from './AlarmFilter';
import AutoConfirm from './AutoConfirmSetting';
import AlarmUpdate from './AlarmUpdate';
import socketInstance from '../../../plugins/stompSock';
import { EventBus } from '../../../plugins/eventBus';
Pager.Inject(PagerDropDown);

// 当前告警默认隐藏的值  增加或减少需要修改本页的数量  导出前22个字段并避免不导出页面隐藏的字段  后面不显示
const hiddenDefaultVal = { alarmTypeStr: true, xxdwinfo2: true, xxkzinfo1: true, xxkzinfo2: true, xxkzinfo3: true, xxkzinfo4: true, cause: true, advise: true, comment: true };

export default {
  name: 'currentAlarmTable',
  components: {
    AlarmTopoTree,
    CustomDialog,
    AlarmDetail,
    AlarmHidden,
    AlarmFilter,
    AutoConfirm,
    AlarmUpdate,
    "ejs-pager":PagerComponent

  },
  props: {
    roleNe: {
      type: Array,
      default() {
        return [];
      }
    },
    roleNetMap: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      // true 隐藏
      hidden: hiddenDefaultVal,
      styleColorVar: {},
      editOptions: { allowAdding: true, allowDeleting: true, newRowPosition: 'Top' },
      selectionOptions: { type: 'Multiple' },
      contextMenuItems: [
        { text: `${this.$t('Alarm.acknowledge')}` },
        { text: `${this.$t('Alarm.unconfirm')}` },
        { text: `${this.$t('Alarm.clear')}` },
        { text: `${this.$t('Alarm.shield')}` },
        { text: `${this.$t('Alarm.alarmDetails')}` }
      ],
      alarmSocketMaxCapcity: 15,
      conditionsStatus: false,
      topoList: [],
      isOn: '0',
      disabled: true,
      page: {
        pageNo: 1,
      pageSizes: [ 20, 50, 100],
        pageSize: 20,
        totalCount: 0,
        pageCount: 10
      },
      queryConditions: {
        systemId: '1',
        conditions: '', // 告警过滤时会有查询条件，筛调部分告警，初始化时需获取初始条件
        keywords: '', // 模糊查询关键字
      },
      gridCheckFlag: false,
      data: {},
      clearOrConfirmMessage: '',
      isAutoOption: true, // 记录当前是否为自动清除告警
      syncDialogSetting: {
        styles: {
          width: '600px',
          height: '70%',
          model: true,
          visible: false
        },
        element: {
          title: this.$t('Alarm.alarmAynchronize'),
          refName: 'sync',
          isClose: true,
          buttonGroup: [
            { click: this.dialogHide, buttonModel: { content: this.$t('Alarm.cancel') } },
            { click: this.syncConfirmFunc, buttonModel: { content: this.$t('Alarm.confirm'), isPrimary: true } }
          ]
        }
      },
      detailDialogSetting: {
        styles: {
          width: '810px',
          height: 'auto',
          model: true,
          visible: false
        },
        element: {
          title: this.$t('Alarm.alarmDetails'),
          target: '#app',
          refName: 'detail',
          isClose: true,
          buttonGroup: [
            { click: this.dialogHide, buttonModel: { content: this.$t('Common.cancel') } },
            { click: this.saveDetails, buttonModel: { content: this.$t("Profile.confirm"), isPrimary: true } }

          ]
        }
      },
      hiddenDialogSetting: {
        styles: {
          width: '510px',
          height: 'auto',
          model: true,
          visible: false
        },
        element: {
          title: this.$t('Alarm.showSetting'),
          target: '#app',
          refName: 'hidden',
          isClose: true,
          buttonGroup: [
            { click: this.dialogHide, buttonModel: { content: this.$t('Common.cancel') } },
            { click: this.hiddenConfirmFunc, buttonModel: { content: this.$t('Alarm.confirm'), isPrimary: true } }
          ]
        }
      },
      filterDialogSetting: {
        styles: {
          width: '810px',
          height: 'auto',
          model: true,
          visible: false
        },
        element: {
          title: this.$t('Alarm.filterSetting'),
          refName: 'filter',
          isClose: true,
          buttonGroup: [
            { click: this.dialogHide, buttonModel: { content: this.$t('Alarm.cancel') } },
            // { click: this.filterFilterFunc, buttonModel: { content: this.$t('Alarm.filter'), isPrimary: true } },
            { click: this.filterConfirmFunc, buttonModel: { content: this.$t('Alarm.confirm'), isPrimary: true } }
          ]
        }
      },
      autoConfirmDialogSetting: {
        styles: {
          width: '1000px',
          height: 'auto',
          model: true,
          visible: false
        },
        element: {
          title: this.$t('Alarm.confirmSetting'),
          refName: 'autoConfirm',
          isClose: true,
          buttonGroup: [
            { click: this.dialogHide, buttonModel: { content: this.$t('Alarm.cancel') } },
            { click: this.autoConfirmSureFunc, buttonModel: { content: this.$t('Alarm.confirm'), isPrimary: true } }
          ]
        }
      },
      updateDialogSetting: {
        styles: {
          width: '1000px',
          height: 'auto',
          model: true,
          visible: false
        },
        element: {
          title: this.$t('Alarm.alarmUpdate'),
          refName: 'update',
          isClose: true,
          buttonGroup: [
            { click: this.dialogHide, buttonModel: { content: this.$t('Alarm.cancel') } },
            { click: this.confirmUpdateFunc, buttonModel: { content: this.$t('Alarm.confirm'), isPrimary: true } }
          ]
        }
      },
      websocketSetting: [
        // { topic: '/topic/#', clientId: 'CurrentAlarmServer', callback: this.websocketCallback }
        { topic: '/user/#/CurrentAlarmServer', clientId: 'alarm', callback: this.websocketCallback }
      ],
      //排序字段
      sortColumn: {},
      levelStrDirection : "",
      equipmentNameDirection : "",
      createTimeDirection : "",
    };
  },
  provide: {
    grid: [Edit, Reorder, Resize, ExcelExport, ContextMenu, VirtualScroll,Sort]
  },
  methods: {
    levelFormat(grids, data) {
      data.levelStr = this.$t(`Alarm.alarmLevel_${data.level}`);
      return `<span class='h-alarmLevel${data.level}'>${this.$t(`Alarm.alarmLevel_${data.level}`)}</span>`;
    },
    isVirtualFormat(grids, data){
      //现在36-48为5G网元，255 VDOS没有告警，不考虑
      if(data.nodeTypeId > 99){
        return this.$t(`Alarm.physics`);
      }else{
        return this.$t("Alarm.virtualNet");
      }
    },
    typeFormat(grid, data) {
      let str = this.$t(`Alarm.alarmType_${data.alarmType}`);
      data.alarmTypeStr = str;
      return str;
    },
    clearFormat(grid, data) {
      let str = this.$t(`Alarm.alarmClearStatus_${data.clearState}`);
      data.clearStateStr = str;
      return str;
    },
    confirmFormat(grid, data) {
      let str = this.$t(`Alarm.alarmConfirmStatus_${data.confirmState}`);
      data.confirmStateStr = str;
      return str;
    },
    menuBeforeOpenFunc(menuArgs) { // 屏蔽表头的右键事件
      if (!menuArgs.rowInfo.rowIndex && menuArgs.rowInfo.rowIndex !== 0) {
        menuArgs.cancel = true;
      }
      const childList = menuArgs.element.querySelectorAll('li.e-menu-item');
      childList[childList.length - 1].style.display = this.getCheckedData(true).length > 1 ? 'none' : 'block';
    },
    menuClickFunc(menuArgs) { // 为右键分配事件
      switch (menuArgs.element.innerText) {
        case `${this.$t('Alarm.acknowledge')}`:
          this.confirmAlarm();
          break;
        case `${this.$t('Alarm.unconfirm')}`:
          this.unconfirmAlarm();
          break;
        case `${this.$t('Alarm.clear')}`:
          this.clearAlarm();
          break;
        case `${this.$t('Alarm.shield')}`:
          this.shieldAlarm();
          break;
        case `${this.$t('Alarm.alarmDetails')}`:
          this.showDetail();
          break;
        default:
      }
    },
    dialogHide() {
      this.$refs.syncDialog.clear();
      this.$refs.syncDialog.close();
      this.$refs.detailDialog.clear();
      this.$refs.detailDialog.close();
      this.$refs.hiddenDialog.clear();
      this.$refs.hiddenDialog.close();
      this.$refs.filterDialog.clear();
      this.$refs.filterDialog.close();
      this.$refs.autoConfirmDialog.clear();
      this.$refs.autoConfirmDialog.close();
      this.$refs.updateDialog.clear();
      this.$refs.updateDialog.close();
    },
    getColumnsMapper() {
      return `messageNo:${this.$t('Alarm.messageNo')};`
        + `alarmID:${this.$t('Alarm.alarmID')};`
        + `alarmName:${this.$t('Alarm.alarmName')};`
        + `levelStr:${this.$t('Alarm.alarmLevel')};`
        + `alarmTypeStr:${this.$t('Alarm.alarmType')};`
        + `nodeType:${this.$t('Topo.nodeType')};`
        + `neTypeStr:${this.$t('Alarm.neType')};`
        + `neName:${this.$t('Alarm.neName')};`
        + `neAlarmFDN:${this.$t('Alarm.neAlarmFDN')};`
        + `brdType:${this.$t('Alarm.brdType')};`
        + `clearStateStr:${this.$t('Alarm.clearState')};`
        + `confirmStateStr:${this.$t('Alarm.confirmState')};`
        + `createTimeFormat:${this.$t('Alarm.createTime')};`
        + `clearTimeFormat:${this.$t('Alarm.clearTime')};`
        + `confirmTimeFormat:${this.$t('Alarm.confirmTime')};`
        + `clearUsrName:${this.$t('Alarm.clearUser')};`
        + `confirmUsrName:${this.$t('Alarm.confirmUser')};`
        + `comment:${this.$t('Alarm.remark')};`
        + `xxdwinfo1:${this.$t('Alarm.xxdwinfo1')};`
        + `xxdwinfo2:${this.$t('Alarm.xxdwinfo2')};`
        + `xxkzinfo1:${this.$t('Alarm.xxkzinfo1')};`
        + `xxkzinfo2:${this.$t('Alarm.xxkzinfo2')};`
        + `xxkzinfo3:${this.$t('Alarm.xxkzinfo3')};`
        + `xxkzinfo4:${this.$t('Alarm.xxkzinfo4')};`
        + `cause:${this.$t('Alarm.cause')};`
        + `advise:${this.$t('Alarm.advise')};`;
    },
    websocketInit() {
      socketInstance.init(this.websocketSetting);
    },
    websocketCallback(msg) {
      const data = JSON.parse(msg.body);
      if (data.type === 'currentAlarm') { // 新告警
        if (parseInt(this.isOn, 10) === 1) {
          const alarmDataList = JSON.parse(data.data);
          if (this.alarmSocketCapcityFlag(alarmDataList)) {
            this.getAlarmListData();
          } else {
            for (let i = 0; i < alarmDataList.length; i++) {
              setTimeout(() => {
                if ((this.roleNetMap[alarmDataList[i].nodeId] && this.roleNetMap[alarmDataList[i].nodeId] === 1)) {
                  this.$refs.grid.addRecord(alarmDataList[i]);
                  const count = {
                    totalAlarmCount: 0,
                    criticalAlarmCount: 0,
                    majorAlarmCount: 0,
                    minorAlarmCount: 0,
                    warningAlarmCount: 0
                  };
                  count.totalAlarmCount = 1;
                  switch (alarmDataList[i].level) {
                    case 0: count.criticalAlarmCount = 1; break;
                    case 1: count.majorAlarmCount = 1; break;
                    case 2: count.minorAlarmCount = 1; break;
                    case 3: count.warningAlarmCount = 1; break;
                    default:
                  }
                  this.$emit('updataCount', count);
                }
              }, (parseInt(1000 / this.alarmSocketMaxCapcity)) * i);
            }
          }
        }
      } else if (data.type === 'autoAlarm') {
        const removeAlarmDataList = JSON.parse(data.data).removeData;
        const alarmDataList = JSON.parse(data.data).updateData;
        for (let i = 0; i < removeAlarmDataList.length; i++) {
          const index = this.data.findIndex(v => v.messageNo === parseInt(removeAlarmDataList[i], 10));
          if (index > -1) {
            const rowData = this.data[index];
            const count = {
              totalAlarmCount: 0,
              criticalAlarmCount: 0,
              majorAlarmCount: 0,
              minorAlarmCount: 0,
              warningAlarmCount: 0
            };
            count.totalAlarmCount = -1;
            switch (rowData.level) {
              case 0: count.criticalAlarmCount = -1; break;
              case 1: count.majorAlarmCount = -1; break;
              case 2: count.minorAlarmCount = -1; break;
              case 3: count.warningAlarmCount = -1; break;
              default:
            }
            this.$emit('updataCount', count);
            this.$refs.grid.deleteRecord("messageNo", rowData);
          }
        }
        for (let i = 0; i < alarmDataList.length; i++) {
          const index = this.data.findIndex(v => v.messageNo === alarmDataList[i].messageNo);
          if (index > -1) {
            this.$refs.grid.updateRow(alarmDataList[i].messageNo, alarmDataList[i]);
          }
        }
      }
    },
    alarmSocketCapcityFlag(alarmDataList) {
      console.log('alarmDataList', alarmDataList.length);
      let almCount = 0;
      for (let i = 0; i < alarmDataList.length; i++) {
        if ((this.roleNetMap[alarmDataList[i].nodeId] && this.roleNetMap[alarmDataList[i].nodeId] === 1)) {
          almCount ++;
          if (almCount === this.alarmSocketMaxCapcity) {
            break;
          }
        }
      }
      if (almCount === this.alarmSocketMaxCapcity) {
        return true;
      }
      return false;
    },
    actionComplete(args) {

      if (args.requestType === 'sorting' ) {
        this.columnMenuClick(args.columnName,args.direction);
      }

      if (args.requestType === 'reorder') {
        this.currentAlarmTableSort();
      }
      if (args.action === 'add' || args.requestType === 'delete') { // 添加时会默认选中增加的行，现取消选择
        this.$refs.grid.selectRows([]);
      }
      this.disabled = false;
      // this.bindTitle();
      this.$refs.grid.selectRow(0, true);
      this.$refs.grid.selectRow(0, true);
    
    },
    getCheckedData(selectOnly) {
      // false: 不支持多选   true: 支持多选
      const selectedRecords = this.$refs.grid.getSelectedRecords();
      if (selectedRecords.length < 1) {
        EventBus.$emit('toast', {type: 'warning', content: this.$t('Alarm.no_checked')});
        return false;
      }
      if (selectedRecords.length > 1 && !selectOnly) {
        EventBus.$emit('toast', {type: 'warning', content: this.$t('Common.tips.onlyOneSelect')});
        return false;
      }
      return selectedRecords;
    },
    getCheckedVals() {
      const messageNos = [];
      const checkedData = this.getCheckedData(true);
      for (let i = 0; i < checkedData.length; i++) {
        messageNos.push(checkedData[i].messageNo);
      }
      return messageNos;
    },
    getAlarmListData(firstFlag) {
      // 获取表格数据
      const This = this;
      this.page.pageSize=This.$refs.pager.ej2Instances.pageSize;
      let conditionsStr = '';
      let keywordsStr = '';
      if (This.conditionsStatus === true) {
        conditionsStr = This.queryConditions.conditions;
      } else {
        keywordsStr = This.queryConditions.keywords;
      }
      This.page.pageNo = This.$refs.pager.ej2Instances.currentPage;
      if (This.page.pageNo == 1) {
        This.$refs.pager.ej2Instances.currentPage = 1;
      }
      this.$emit('count', {
        conditions: conditionsStr,
        keywords: keywordsStr
      });
      if (firstFlag == true) {
        This.page.pageNo = 1;
        This.$refs.pager.ej2Instances.currentPage = 1;
      }


      //设置隐藏列
      This.$axios.post('/lte/ems/fm/alarmcurrent/getHiddenInfo').then((response) => {
        if (response && response.status === 200) {
          const resultValJson = response.data.resultVal;
          // 表没有值，返回null，显示隐藏页面全部勾选，返回{}
          if (resultValJson === null) {
            this.hidden = hiddenDefaultVal;
          } else if (JSON.stringify(resultValJson) === '{}') {
            this.hidden = {};
          } else {
            this.hidden = resultValJson;
          }
        }
      });

      let principal = sessionStorage.getItem('principal');
      let user = JSON.parse(principal);
      let userId = user.userId;

      This.$axios.post('/lte/ems/fm/alarmcurrent/queryAlarmPage', {
        page: {
          pageNo: This.page.pageNo,
          pageSize: This.page.pageSize
        },
        conditions: conditionsStr,
        keywords: keywordsStr,
        roleNe: This.roleNe,
        userId: userId,
        sortColumn: This.sortColumn
      }).then((response) => {
        if (response && response.status === 200 && response.data.resultVal !== null) {
          This.page.totalCount = response.data.resultVal.totalCount;
          This.data = response.data.resultVal.result;
        }
      });
    },
    exportAlarmListData() {
      const This = this;
      const checkedData = This.getCheckedData(true);

      if (checkedData) {
        for (let i = 0; i < checkedData.length; i++) {
          //现在36-48为5G网元，255 VDOS没有告警，不考虑
          if(checkedData[i].nodeTypeId > 99){
            checkedData[i].nodeTypeId = this.$t(`Alarm.physics`);
          }else{
            checkedData[i].nodeTypeId = this.$t("Alarm.virtualNet");
          }
        }
        const exportProperties = {
          fileName: `${this.$t('Alarm.currentAlarm')}.xlsx`,
          dataSource: checkedData
        };
        This.$refs.grid.getColumns()[0].visible = false;
        // 导出前22个字段并避免不导出页面隐藏的字段
        for (let i = 1; i < 23; i++) {
          This.$refs.grid.getColumns()[i].visible = true;
        }
/*        for (let i = 19; i < This.$refs.grid.getColumns().length; i++) {
          This.$refs.grid.getColumns()[i].visible = true;
        }*/
        This.$refs.grid.excelExport(exportProperties).then(() => {
        // Excel 导出完成后恢复分页状态
        this.$nextTick(() => {
          This.$refs.grid.getColumns()[0].visible = true;
          This.$refs.grid.getColumns()[5].visible = false;
          for (let i = 15; i < 23; i++) {
            This.$refs.grid.getColumns()[i].visible = false;
          }
        });
      });
    }
    },
    exportAllAlarmListData() {
      console.log('export All current Alarm List Data');
      // 获取表格数据
      const This = this;
      let conditionsStr = '';
      let keywordsStr = '';

      if (This.conditionsStatus === true) {
        conditionsStr = This.queryConditions.conditions;
      } else {
        keywordsStr = This.queryConditions.keywords;
      }
      const principal = sessionStorage.getItem('principal');
      const user = JSON.parse(principal);

      const params = {
        conditions: conditionsStr,
        keywords: keywordsStr,
        roleNe: This.roleNe,
        userId: user.userId,
        exportType: {
          // xls,xlsx,csv
          exportFileType: 'xlsx',
        },
        fileParam: {
          fileName: `${this.$t('Alarm.currentAlarm')}`,
          header: [this.$t('Alarm.messageNo'), this.$t('Alarm.alarmID'), this.$t('Alarm.alarmName'), this.$t('Alarm.alarmLevel'), this.$t('Alarm.alarmType'), this.$t('Alarm.equipmentName'), this.$t('Alarm.neAlarmFDN'), this.$t('Alarm.brdType'), this.$t('Alarm.extraInfo'), this.$t('Alarm.xxdwinfo1'), this.$t('Alarm.createTime'), this.$t('Alarm.confirmState'), this.$t('Alarm.confirmTime'), this.$t('Alarm.confirmUser'), this.$t('Alarm.xxdwinfo2'), this.$t('Alarm.xxkzinfo1'), this.$t('Alarm.xxkzinfo2'), this.$t('Alarm.xxkzinfo3'), this.$t('Alarm.xxkzinfo4'), this.$t('Alarm.cause'), this.$t('Alarm.advise'), this.$t('Alarm.remark')],
          formatI18n: [this.$t('Alarm.alarmType_0'), this.$t('Alarm.alarmType_1'), this.$t('Alarm.alarmType_2'), this.$t('Alarm.alarmType_3'), this.$t('Alarm.alarmConfirmStatus_0'), this.$t('Alarm.alarmConfirmStatus_1'), this.$t('Alarm.alarmLevel_0'), this.$t('Alarm.alarmLevel_1'), this.$t('Alarm.alarmLevel_2'), this.$t('Alarm.alarmLevel_3')],
        },
      };
      console.log('params', params);
      const config = {
        responseType: 'blob',
        // 2023-8-8 韩洪波：设置该请求的超时时间为6分钟, 全局超时1分钟在axios.js中配置
        timeout: 6 * 60 * 1000
      };
      // EventBus.$emit('loading', { ison: true });
      this.$loading.showLoadding(this.$t('DeployManagement.exporting'));
      this.$axios.post('/lte/ems/fm/alarmcurrent/exportAllData', params, config).then((res) => {
        // 判断是否错误
        const reader = new FileReader(); // 创建读取文件对象
        reader.readAsText(res.data, 'utf-8'); // 设置读取的数据以及返回的数据类型为utf-8
        // eslint-disable-next-line func-names
        reader.addEventListener('loadend', () => {
          // EventBus.$emit('loading', { ison: false });
          this.$loading.hideLoadding();
          if (reader.result.indexOf('{') === 0) {
            const resJson = JSON.parse(reader.result);
            if (resJson.errorCode === '1117') {
              // 超过最大同时导出数量
              EventBus.$emit('toast', { type: 'warning', content: This.$t('Alarm.moreThanMaxConcurrentExportNum') });
            } else if (resJson.errorCode === '1119') {
              // 超过最大导出明细数量
              EventBus.$emit('toast', { type: 'warning', content: This.$t('Alarm.moreThanMaxExportDetailNum') });
            } else if (resJson.errorCode === '1120') {
              // 查询结果数量为0
              EventBus.$emit('toast', { type: 'warning', content: This.$t('Alarm.resultCountIsZero') });
            } else {
              EventBus.$emit('toast', { type: 'warning', content: This.$t('Pm.unknownError') });
              console.log('reader.result:', reader.result);
            }
            return;
          }
          const link = document.createElement('a');
          const blob = new Blob([res.data], { type: 'application/vnd.ms-excel' });
          link.style.display = 'none';
          link.href = URL.createObjectURL(blob);
          const dateStr = new Date().Format('yyyyMMddHHmmss');
          link.setAttribute('download', `${This.$t('Alarm.currentAlarm') + dateStr}.xlsx`);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        });
      });
    },
    excelExportComplete() {
      this.$refs.grid.getColumns()[0].visible = true;
      // 第20个字段后面的设置不可见
      for (let i = 20; i < this.$refs.grid.getColumns().length; i++) {
        this.$refs.grid.getColumns()[i].visible = false;
      }
    },
    syncFunc() {
      // 同步
      this.$refs.syncDialog.show();
      this.$refs.syncContent.createTree();
      // this.$refs.syncContent.uncheckAll();
    },
    syncConfirmFunc() {
      // 点击同步弹窗确认按钮
      /* 获取树勾选的节点
       * 拼接后调用接口，返回数据后关闭弹窗
       */
      const This = this;
      const neIdList = This.$refs.syncContent.getCheckNode();
      if (neIdList&& neIdList.length !== 0) {
        This.$axios.post('/lte/ems/fm/alarmcurrent/synRule', neIdList).then((response) => {
          if (response && response.status === 200 && response.data.errorCode === 'SUCCESS') {
            EventBus.$emit('toast', {type: 'success', content: this.$t('Alarm.syncSuccess')});
          } else {
            EventBus.$emit('toast', {type: 'error', content: this.$t('Alarm.syncError')});
          }
          this.dialogHide();
        });
      } else {
        EventBus.$emit('toast', {type: 'warning', content: this.$t('Alarm.pleaseSelectNe')});
      }
    },
    confirmAlarm() {
      // 告警确认
      const This = this;
      const checkedData = This.getCheckedData(true);
      if (checkedData) {
        This.$axios.post('/lte/ems/fm/alarmcurrent/confirm', This.getCheckedVals()).then((response) => {
          if (response && response.status === 200 && response.data.errorCode === 'SUCCESS') {
            This.isAutoOption = false;
            This.clearOrConfirmMessage = `${this.$t('Alarm.success')} ${response.data.resultVal.message}`;
            EventBus.$emit('toast', {type: 'success', content: This.clearOrConfirmMessage});
            This.page.pageNo = 1;
            This.getAlarmListData(true);
          }
        });
      }
    },
    unconfirmAlarm() {
      // 告警反确认
      let username = '';
      let principal = sessionStorage.getItem('principal');
      if (!!principal) {
        let user = JSON.parse(principal);
        username = user.username;
      }
      const This = this;
      const checkedData = This.getCheckedData(true);

      if(checkedData[0].confirmState == 0){
        EventBus.$emit('toast', {type: 'warning', content: This.$t('Alarm.unconfirm_unconfirm')});
        return ;
      }
      if(username == 'Eadmin' || checkedData[0].confirmUsrName == username || username == 'unmadmin'){
        This.$axios.post('/lte/ems/fm/alarmcurrent/unconfirm', This.getCheckedVals()).then((response) => {
          if (response && response.status === 200 && response.data.errorCode === 'SUCCESS') {
            This.isAutoOption = false;
            This.clearOrConfirmMessage = `${this.$t('Alarm.success')} ${response.data.resultVal.message}`;
            EventBus.$emit('toast', {type: 'success', content: This.clearOrConfirmMessage});
            This.page.pageNo = 1;
            This.getAlarmListData(true);
          }
        });
        // EventBus.$emit('toast', {type: 'success', content: `${this.$t('Alarm.unconfirm')} ${this.$t('Alarm.success')}` });
        return ;
      }
      EventBus.$emit('toast', {type: 'warning', content: This.$t('Alarm.noPermission')});

    },
    clearAlarm() {
      // 告警清除
      const This = this;
      const checkedData = This.getCheckedData(true);
      if (checkedData) {
        This.$axios.post('/lte/ems/fm/alarmcurrent/clear', This.getCheckedVals()).then((response) => {
          if (response && response.status === 200 && response.data.errorCode === 'SUCCESS') {
            This.isAutoOption = false;
            This.clearOrConfirmMessage = `${this.$t('Alarm.success')} ${response.data.resultVal.message}`;
            EventBus.$emit('toast', {type: 'success', content: This.clearOrConfirmMessage});
            This.page.pageNo = 1;
            This.getAlarmListData(true);
          }
        });
      }
    },
    showDetail() {
      // 告警详情
      const checkedData = this.getCheckedData(false);
      if (checkedData) {
        this.$refs.detailDialog.show();
        this.$refs.detailContent.setAlarmId(checkedData[0]);
      }
    },
    shieldAlarm() {
      // 告警屏蔽
      const checkedData = this.getCheckedData(true);
      if (checkedData) {
        let insideAlarmFlag = false;
        checkedData.forEach((item) => {
          if ((item.alarmID >= 29600 && item.alarmID <= 29999 ) || (item.alarmID >= 39900 && item.alarmID <=40100)) {
            insideAlarmFlag = true;
            return false;
          } 
          return true;
        });
        if (insideAlarmFlag === true) {
          EventBus.$emit('toast', {type: 'warn', content: this.$t('Alarm.insideAlarmNotAllowShield')});
          return;
        }
        this.$axios.post('/lte/ems/fm/alarmcurrent/shield', this.getCheckedVals()).then((response) => {
          if (response && response.status === 200 && response.data.errorCode === 'SUCCESS') {
            EventBus.$emit('toast', {type: 'success', content: this.$t('Alarm.success')});
          } else {
            EventBus.$emit('toast', {type: 'error', content: this.$t('Alarm.error')});
          }
        });
      }
    },
    filterFunc() {
      // 告警过滤
      this.$refs.filterDialog.show();
      this.$refs.filterContent.setTopoList(this.topoList);
      this.$refs.filterContent.setConditions(this.queryConditions.conditions);

    },
    hiddenFunc() {
      // 隐藏
      this.$refs.hiddenDialog.show();
      this.$refs.hiddenContent.setHiddenInfo(this.hidden);
    },
    hiddenConfirmFunc(clickEvent) {
      if (clickEvent.keyCode === 13) {
        return;
      }
      this.dialogHide();
      // 获取表格数据
      const This = this;
      const hiddenInfo = this.$refs.hiddenContent.getHiddenInfo();
      This.$axios.post('/lte/ems/fm/alarmcurrent/saveHiddenInfo', {
        hiddenInfo: hiddenInfo
      }).then((response) => {
        if (response && response.status === 200) {
          console.log(response.data.resultVal);
          // 设置显示/隐藏后，自动刷新
          // 设置隐藏列：["alarmTypeStr"]
          // 获取隐藏列： {alarmTypeStr: true, alarmID: true, alarmName: true, levelStr: true}
          This.$axios.post('/lte/ems/fm/alarmcurrent/getHiddenInfo').then((response1) => {
            if (response1 && response1.status === 200) {
              const resultValJson = response1.data.resultVal;
              // 表没有值，返回null，显示隐藏页面全部勾选，返回{}
              if (resultValJson === null) {
                this.hidden = hiddenDefaultVal;
              } else if (JSON.stringify(resultValJson) === '{}') {
                this.hidden = {};
              } else {
                this.hidden = resultValJson;
              }
            }
          });
        }
      });
      setTimeout(() => {
        this.currentAlarmTableSort();
      }, 800);
    },
    filterConfirmFunc(clickEvent) {
      if (clickEvent.keyCode === 13) {
        return;
      }
      // 告警过滤确认事件
      this.queryConditions.conditions = this.$refs.filterContent.getConditions();
      const conditions = JSON.parse(this.queryConditions.conditions);
      conditions.flag = true;
      this.queryConditions.conditions = JSON.stringify(conditions);
      this.topoList = this.$refs.filterContent.getTopoList();
      this.dialogHide();
      EventBus.$emit('toast', { type: 'success', content: this.$t('Alarm.success') });
      this.conditionsStatus = true;
      this.getAlarmListData(true);
    },
    // 告警显示过滤
    filterFilterFunc(clickEvent) {
      if (clickEvent.keyCode === 13) {
        return;
      }
      this.queryConditions.conditions = this.$refs.filterContent.getConditions();
      const conditions = JSON.parse(this.queryConditions.conditions);
      conditions.flag = false;
      this.queryConditions.conditions = JSON.stringify(conditions);
      this.topoList = this.$refs.filterContent.getTopoList();

      this.dialogHide();
      this.conditionsStatus = true;
      this.getAlarmListData(true);
    },
    autoConfirmFunc() {
      // 告警自动确认
      this.$refs.autoConfirmDialog.show();
      this.$refs.autoConfigContent.getAutoConfirmInfo();
    },
    updateFunc() {
      // 告警升级
      this.$refs.updateDialog.show();
      this.$refs.updateSettingContent.getCommonSettingInfo();
    },
    confirmUpdateFunc(){
      const data = this.$refs.updateSettingContent.getSettingData();
      if (data) {
        this.$axios.post('/lte/ems/fm/setting/updateSetting', JSON.parse(data)).then((response) => {
          if (response && response.status === 200) {
            EventBus.$emit('toast', {type: 'success', content: this.$t('Alarm.success')});
          }
        });
        this.dialogHide();
      }
    },
    autoConfirmSureFunc() {
      // 告警自动确认按钮事件
      const data = this.$refs.autoConfigContent.getConditionData();
      if (data) {
        this.$axios.post('/lte/ems/fm/alarmcurrent/autoConfirmCondition', JSON.parse(data)).then((response) => {
          if (response && response.status === 200) {
            EventBus.$emit('toast', {type: 'success', content: this.$t('Alarm.success')});
          }
        });
        this.dialogHide();
      }
    },
    saveDetails(){
      const detail = this.$refs.detailContent.getAlarmDetails();
      this.$axios.post('/lte/ems/fm/alarmcurrent/changeDetails', detail).then((response) => {
          if (response && response.status === 200 && response.data.errorCode === 'SUCCESS') {
            EventBus.$emit('toast', {type: 'success', content: this.$t('Common.tips.success')});
            this.dialogHide();
            this.getAlarmListData(true);

          }
        });
    },
    alarmSyncFunc(){
      const This = this;
      This.$layer.confirm({
        msg: This.$t('Alarm.alarmSyncConfirmTip'),
        btn1: {
          msg: This.$t('Alarm.cancel'),
        },
        btn2: {
          msg: This.$t('Alarm.confirm'),
          func: () => {
            This.$loading.showLoadding(This.$t('Alarm.alarmSyncLoad'));
            This.$axios.post('/lte/ems/fm/alarmcurrent/synchronizeAllAlarmData').then((response) => {
              This.$loading.hideLoadding();
              if (response && response.status === 200) {
                if(response.data.resultVal === "1"){
                  EventBus.$emit('toast', {type: 'success', content: This.$t('Alarm.syncSuccess')});
                }else{
                  EventBus.$emit('toast', {type: 'success', content: This.$t('Alarm.syncSuccess')});
                }
              } else {
                EventBus.$emit('toast', {type: 'error', content: This.$t('Alarm.syncError')});
              }
            });
          }
        }
      });
    },
    columnMenuClick(columnName, direction) {
      if (columnName === 'levelStr' && direction === "Ascending") {
        this.sortColumn = {};
        this.sortColumn.alarmLevel = "asc"
      } else if(columnName === 'levelStr' && direction === "Descending") {
        this.sortColumn = {};
        this.sortColumn.alarmLevel = "desc"
      } else if (columnName === "equipmentName" && direction === "Ascending") {
        this.sortColumn = {};
        this.sortColumn.nodeName = "asc"
      } else if(columnName === "equipmentName" && direction === "Descending") {
        this.sortColumn = {};
        this.sortColumn.nodeName = "desc"
      } else if (columnName === "createTimeFormat" && direction === "Ascending") {
        this.sortColumn = {};
        this.sortColumn.createTime = "asc"
      } else if(columnName === "createTimeFormat" && direction === "Descending") {
        this.sortColumn = {};
        this.sortColumn.createTime = "desc"
      }
      this.getAlarmListData(true);
    },
    currentAlarmTableSort() {
      const This = this;
      this.styleColorVar = JSON.parse(localStorage.getItem('styleColorVar'));
      // 为了导致页面分层问题，将以tab的id区别
      var rootElement =document.getElementById("account_tab2");
      console.log("account_tab2.levelStrColumn=================",rootElement);
      var levelStrColumn = rootElement.getElementsByClassName("e-headercell e-centeralign e-mousepointer");
      for (let i = 0; i < levelStrColumn.length; i++) {
        var thElement = levelStrColumn[i];
        var firstDivElement = thElement.querySelector("div");
        var spanElement = firstDivElement.querySelector("span");
        var spanContent = spanElement.textContent;
        if (spanContent === "Alarm Level" || spanContent === "告警级别") {
          thElement.addEventListener("click", function(event) {
            if (This.levelStrDirection === "") {
              This.levelStrDirection = "Ascending";
              This.equipmentNameDirection = "";
              This.createTimeDirection = "";
              This.columnMenuClick('levelStr', "Ascending");
            }
            else if (This.levelStrDirection === "Ascending") {
              This.levelStrDirection = "Descending";
              This.equipmentNameDirection = "";
              This.createTimeDirection = "";
              This.columnMenuClick('levelStr', "Descending");
            } else if (This.levelStrDirection === "Descending") {
              This.levelStrDirection = "";
              This.sortColumn = {};
              This.getAlarmListData(true);
            }
          });
        } else if (spanContent === "Device Name" || spanContent === "设备名称") {
          thElement.addEventListener("click", function(event) {
            if (This.equipmentNameDirection === "") {
              This.levelStrDirection = "";
              This.equipmentNameDirection = "Ascending";
              This.createTimeDirection = "";
              This.columnMenuClick('equipmentName', "Ascending");
            } else if (This.equipmentNameDirection === "Ascending") {
              This.levelStrDirection = "";
              This.equipmentNameDirection = "Descending";
              This.createTimeDirection = "";
              This.columnMenuClick('equipmentName', "Descending");
            } else if (This.equipmentNameDirection === "Descending") {
              This.equipmentNameDirection = "";
              This.sortColumn = {};
              This.getAlarmListData(true);
            }
          });
        } else if (spanContent === "Occurrence Time" || spanContent === "产生时间") {
          thElement.addEventListener("click", function(event) {
            if (This.createTimeDirection === "") {
              This.levelStrDirection = "";
              This.equipmentNameDirection = "";
              This.createTimeDirection = "Ascending";
              This.columnMenuClick('createTimeFormat', "Ascending");
            } else if (This.createTimeDirection === "Ascending") {
              This.levelStrDirection = "";
              This.equipmentNameDirection = "";
              This.createTimeDirection = "Descending";
              This.columnMenuClick('createTimeFormat', "Descending");
            } else if (This.createTimeDirection === "Descending") {
              This.createTimeDirection = "";
              This.sortColumn = {};
              This.getAlarmListData(true);
            }
          });
        }
      }
    }
    

  },
  mounted() {
    this.websocketInit();
    this.styleColorVar = JSON.parse(localStorage.getItem('styleColorVar'));
    // this.currentAlarmTableSort();
  },
  eventEmit(type, content) {
      EventBus.$emit('toast', {type: type, content: content})
    },
  beforeDestroy() {
    for (let i = 0; i < this.websocketSetting.length; i++) {
      socketInstance.stopReceiveTopicMsg(this.websocketSetting[i].clientId, this.websocketSetting[i].topic);
    }
  }
};
</script>
